var map = {
	"./anchovy.svg": 9774,
	"./bacon.svg": 2000,
	"./basil.svg": 9743,
	"./chili.svg": 8453,
	"./mozzarella.svg": 8878,
	"./mushroom.svg": 2390,
	"./olive.svg": 5681,
	"./onion.svg": 7538,
	"./pepper.svg": 2581,
	"./pepperoni.svg": 3125,
	"./prawn.svg": 1744,
	"./sweetcorn.svg": 564,
	"./tomato.svg": 5256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9449;